import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { appLayoutRoute } from "../router/rootRoutes";

export const designSystemRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/_design-system",
  component: lazyRouteComponent(() => import("./DesignSystemPage"), "DesignSystemPage"),
});
